export const FETCH_SCENARIOS = 'FETCH_SCENARIOS';
export const FETCH_ALLOWED_PERIODS_FOR_SCENARIOS = 'FETCH_ALLOWED_PERIODS_FOR_SCENARIOS';

export const SET_SELECTED_COMPARE_SCENARIO = 'SET_SELECTED_COMPARE_SCENARIO';
export const SET_SELECTED_SCENARIO_VIEW = 'SET_SELECTED_SCENARIO_VIEW';
export const SET_SELECTED_SCENARIO_EDIT_CY = 'SET_SELECTED_SCENARIO_EDIT_CY';
export const SET_SELECTED_SCENARIO_CURRENCY = 'SET_SELECTED_SCENARIO_CURRENCY';

export const CALCULATE_SCENARIO = 'CALCULATE_SCENARIO';
export const CALCULATE_SCENARIO_SUCCESS = 'CALCULATE_SCENARIO_SUCCESS';
export const CALCULATE_SCENARIO_FAILURE = 'CALCULATE_SCENARIO_FAILURE';

export const FETCH_SCENARIO_REPORT_DATA = 'FETCH_SCENARIO_REPORT_DATA';
export const FETCH_SCENARIO_REPORT_FIELDS = 'FETCH_SCENARIO_REPORT_FIELDS';

export const CLEAR_SCENARIO_REPORT_DATA = 'CLEAR_SCENARIO_REPORT_DATA';

export const UPLOAD_TAGGED_DATA_FILE = 'UPLOAD_TAGGED_DATA_FILE';
export const UPLOAD_TAGGED_DATA_FILE_SUCCESS = 'UPLOAD_TAGGED_DATA_FILE_SUCCESS';
export const UPLOAD_TAGGED_DATA_FILE_FAILURE = 'UPLOAD_TAGGED_DATA_FILE_FAILURE';

export const CLEAR_UPLOAD_TAGGED_DATA_ERRORS = 'CLEAR_UPLOAD_TAGGED_DATA_ERRORS';
